import axios from '../axios';
import * as types from "./types";
import createAction from "./createAction";

import API from "./api";


const baseUrl = API + "/profiles/";

export function getProfiles(payload) {
  return (async dispatch => { 
    try {
      dispatch(createAction(types.GET_PROFILES_LOADING));
      const { data } = await axios.get(`${baseUrl}`);
      dispatch(createAction(types.GET_PROFILES_SUCCESS, data));
    } catch(error) {
      dispatch(createAction(types.GET_PROFILES_FAILURE, error));
    }
  })
}
